/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
//import { ChoiceComp } from './PaymentLeft'
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Button from 'components/form-elements/buttons/Button'
import Radio from 'components/form-elements/radio/Radio'
import { useRequest } from 'hooks/useRequest'
import Loader from 'pages/Loader'
import auth from 'utils/Auth'
import { useNavigate } from 'react-router-dom'
import images from 'assets/images/images'
import Input from 'components/form-elements/Input'
import CurrencyFormatter from 'utils/CurrencyFormatter'
import { useEffectTrigger } from 'redux/features/general/generalSlice'
import { useDispatch } from 'react-redux'
import TriggerButton from 'components/triggerButton/TriggerButton'
import { toast } from 'react-toastify'
import useTranslate from 'hooks/useTranslate'
import {Trans} from 'react-i18next'
import { dataLayerPush } from 'utils/Datalayer'

const PaymentRight = ({setPaymentModal, setPaymentChoice, paymentChoice, getAllBasketPayment, setPaymentModalContent, propLoading}) => {
  const [request,loading] =useRequest();
  const [system, setSystem] = useState('')
  const [metropolStatus, setMetropolStatus] = useState(1)
  //const [paymentParameter, setPaymentParameter] = useState({phone : null, otp: null})
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const {t} = useTranslate()
  const headerOptions = {
    RestaurantId : auth?.getUserChoises()?.restaurantId,
    DeliveryType : auth?.getUserChoises()?.deliveryType,
    NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
    RegionId : auth?.getUserChoises()?.regionId,
  }

  const paymentChange = (e,paymentID,systemName) => {
    setPaymentChoice(prev => ({...prev, [e.target.name] : paymentID}))
  }
  useEffect(() => {
    if (paymentChoice.paymentTypeId) {
      setSystem(getAllBasketPayment?.paymentMethods?.find(p => p.id == paymentChoice.paymentTypeId )?.systemName)
    }
  },[paymentChoice])
  const changeSodexoInput = (e, name) => {
    setPaymentChoice(prev => {
      let paymentParameters = prev.paymentParameters || {};
      paymentParameters[name] = e.target.value;
      return {...prev, paymentParameters: paymentParameters}
    })
  }
  const getPostArray = (orderResult) => {
    const mappedArray = orderResult?.attributes?.length > 0 ? orderResult?.attributes?.map(attribute => {
      return {
        affilication: "Tavuk Dünyası",
        item_brand: "Tavuk Dünyası",
        item_list_name: "Listeleme Sayfası",
        quantity: 1,
        item_variant: 'Ek Ürün',
        item_id: attribute?.productAttributeId,
        price: attribute?.price || 0,
        discount: 0,
        item_category: attribute?.name,
        item_name: attribute?.valueName,

      }
    }) : []
    return mappedArray
  }
  useEffect(() => {
    if(getAllBasketPayment?.items?.length > 0 && paymentChoice?.paymentTypeId){
      const postArray = getAllBasketPayment?.items?.map((item) => {
        if(item?.attributes?.length > 0){
          return [
            ...[{
              item_name: item?.productName,
              affilication: "Tavuk Dünyası",
              discount: item?.discountAmount,
              item_variant:'Ana Ürün',
              index: 0,
              item_brand: "Tavuk Dünyası",
              item_list_name: "Listeleme Sayfası",
              price: item?.unitPrice,
              quantity: item?.quantity,
              item_id: item?.productId,
              item_category: item?.categories?.[0]?.value,
              item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
              item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
          }],
            ...getPostArray(item)
          ]
        }
        return [ {
          item_name: item?.productName,
          affilication: "Tavuk Dünyası",
          discount: item?.discountAmount,
          item_variant:'Ana Ürün',
          index: 0,
          item_brand: "Tavuk Dünyası",
          item_list_name: "Listeleme Sayfası",
          price: item?.price,
          quantity: item?.quantity,
          item_id: item?.productId,
          item_category: item?.categories?.[0]?.value,
          item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
          item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
      }]
      })
      const mergedArray = [].concat(...postArray);
      dataLayerPush({ ecommerce: null });
      dataLayerPush({
        event:"add_payment_info",
        ecommerce: {
        item_list_name: "Listeleme Sayfası",
        currency: "TRY",
        payment_type: getAllBasketPayment.paymentMethods.find(m => m.id == paymentChoice?.paymentTypeId)?.name, 
        value: getAllBasketPayment?.orderTotal,
        items:mergedArray
        }
      })
      }
  },[paymentChoice?.paymentTypeId])
 
  const completeOrder = () => {
  
    if(!paymentChoice?.salesContrat){
      return toast.error(t('approveDistanceSellingAgree'))
    }
    request('/Checkout', {
      method: 'POST',
      headers: headerOptions,
      data: {
        ...paymentChoice
      }
    }).then((res) => {
      if (res.data.ok) {
        dispatch(useEffectTrigger(Math.floor(Math.random() * 1000)))
        const result = res.data.result
        if(result?.isRequireProfileUpdate){
          localStorage.setItem('paymentChoice',JSON.stringify(paymentChoice))
          return navigate('/hesabim?updatePayment=true')
        }

        if(result.orderId && !result?.isRequirePaymentParameters){
          navigate(`/siparis/${result.orderId}?newOrder=${true}`)
        }else if(result.orderId == null && !result?.isRequirePaymentParameters && (system == 'Iyzipay' || system == "Edenred")){
          setPaymentModal(true);
          let content = (
             <iframe 
               src={result?.iframeUrl}
               frameBorder="0"
               scrolling="yes"
               className={`iframeContainer${result?.paymentMethodSystemName}`}
               >
            </iframe>
            
          )
          setPaymentModalContent(content)
        }else if(result.orderId == null && result?.isRequirePaymentParameters && system == "Sodexo"){
          setPaymentModal(true)

          let sodexoParams = {};
          const sodexoPayment = () => {
            //setPaymentChoice(prev => ({...prev, paymentParameters: paymentParameters}))
             request('/Checkout', {
              method: 'POST',
              headers: headerOptions,
              data: {...paymentChoice, paymentParameters: sodexoParams}
            }).then((res) => {
              if (res.data.ok) {
                const result = res.data.result
                if(result.orderId && !result?.isRequirePaymentParameters){
                  window.location = `/payment/result?orderId=${result.orderId}&iframe=false`
                }
              }
            })
          }
          
          
          let content = (
            <div className='sodexoContent'>
               <img src="https://www.cagrimerkezibul.com/wp-content/uploads/2020/09/sodexo-cagri-merkezi.png" alt="" />
               <div className='sodexoContent-warning'>
                  {t('sodexoWarningText')}
               </div>
               <div className='sodexoContent-inputGroup'>
                 <Input
                    containerClassName={''}
                    className={''}
                    labelClassName={'stageTwoLabel'}
                    placeholder={'5XX XXX XX XX'}
                    type={'number'}
                    label={t('sodexoPhonePlaceholder')}
                    name=''
                    value={sodexoParams?.phone}
                    onChange={(e) => sodexoParams.phone = e.target.value}
				         />
                 <Input
                    containerClassName={''}
                    className={''}
                    labelClassName={'stageTwoLabel'}
                    placeholder={'*********'}
                    type={'number'}
                    label={t('enterMobileCode')}
                    name=''
                    value={sodexoParams?.otp}
                    onChange={(e) => sodexoParams.otp = e.target.value}
				         />
                 <button onClick={sodexoPayment}>{t('pay')}</button>
               </div>
            </div> 
          )
          setPaymentModalContent(content)
        }else if(result.orderId == null && result?.isRequirePaymentParameters && system == "Metropol"){
          setPaymentModal(true)
          let metropolParamsOne = {};
          let metropolParamsTwo = {
            //otpRefCode: "f430e31d-7955-4420-93d4-18445270d0a0",
            cardNumber: metropolParamsOne?.cardNumber
          };

          let status = 1

          function cc_format(value) {
            const v = value?.replace(/\s+/g, "")
              ?.replace(/[^0-9]/gi, "")
              ?.substr(0, 16);
            const parts = [];
          
            for (let i = 0; i < v?.length; i += 4) {
              parts.push(v.substr(i, 4));
            }
          
            return parts.length > 1 ? parts.join(" ") : value;
          }


          const metropolCardFuncOne = () => {
            setPaymentModal(false)
            request('/Checkout', {
              method: 'POST',
              headers: headerOptions,
              data: {...paymentChoice, prePaymentParameters: metropolParamsOne}
            }).then((res) => {
              const result = res?.data?.result 
              if (res.data.ok) {
                setPaymentModal(true)
                metropolParamsTwo.otpRefCode = result?.postParameters?.otpRefCode 
                metropolParamsTwo.cardNumber = metropolParamsOne.cardNumber
                metropolParamsOne.cardNumber = null;
                setPaymentModalContent(
                  <div className='metropolContent'>
                  <img src="https://telefonbilgisi.net/wp-content/uploads/2020/02/Metropol.jpg" alt="" />
                   <Input
                    containerClassName={''}
                    className={'mb-2'}
                    labelClassName={'stageTwoLabel'}
                    placeholder={'*********'}
                    type={'text'}
                    label={t('enterMobileCode')}
                    name=''
                    value={metropolParamsTwo?.otp || null}
                    onChange={(e) => metropolParamsTwo.otp = e.target.value}
				         />
                  <button className='claretredRoundedBtn' onClick={metropolCardFuncTwo}>{t('pay')}</button>
                  </div>
                )
              }
            })
          }

          const metropolCardFuncTwo = () => {
            request('/Checkout', {
              method: 'POST',
              headers: headerOptions,
              data: {...paymentChoice, paymentParameters: metropolParamsTwo}
            }).then((res) => {
              const result = res?.data?.result 
              if (res.data.ok) { 
                if(result.orderId){
                  navigate(`/siparis/${result.orderId}?newOrder=${true}`)
                }
              }
            })
          }


           let content = (
            
           <div className='metropolContent'>
                 <>
                   <img src="https://telefonbilgisi.net/wp-content/uploads/2020/02/Metropol.jpg" alt="" />
                   <Input
                    containerClassName={''}
                    className={'mb-2'}
                    labelClassName={'stageTwoLabel'}
                    placeholder={'XXXX XXXX XXXX XXXX'}
                    type={'text'}
                    label={t('enterCardNumber')}
                    name=''
                    value={cc_format(metropolParamsOne?.cardNumber)}
                    onChange={(e) => metropolParamsOne.cardNumber = e.target.value}
				         />
                  <button className='claretredRoundedBtn' onClick={metropolCardFuncOne}>{t('continue2')}</button>
                  </> 
            </div>
            
            
    )
          setPaymentModalContent(content)
          
        } else if(result.orderId == null && system == "Multinet"){
          function post(url, params) {
            const form = document.createElement('form');
            form.method = 'post';
            form.action = url;
            for (const key in params) {
              if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = params[key];
                form.appendChild(hiddenField);
              }
            }
            document.body.appendChild(form);
            form.submit();
            //form.remove();
          }
          post(result.redirectWithPostUrl, result.postParameters)
        }
        else if(result.orderId == null && system == "Setcard"){
          function post(url, params) {
            const form = document.createElement('form');
            form.method = 'post';
            form.action = url;
            for (const key in params) {
              if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = params[key];
                form.appendChild(hiddenField);
              }
            }
            document.body.appendChild(form);
            form.submit();
            //form.remove();
          }
          post(result.redirectWithPostUrl, result.postParameters)
        }
      }
    })

    
  }

  // const discountAmount = [...getAllBasketPayment.items].reduce((a,b) => a + b.discountAmount * b.quantity, 0);


  return (
    <div className='payment-right'>
       <Loader isDataLoading={loading} />
       {
        propLoading ? <>
        	<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
        </> 
        : <>
        <div className='payment-right-title'>{t('totalAmount')}</div>
        <div className='payment-right-price'>{getAllBasketPayment?.orderTotal ? <CurrencyFormatter locale="tr" currency="TRY" value={getAllBasketPayment?.orderTotal} /> : <CurrencyFormatter locale="tr" currency="TRY" value={"00"} />}</div>
        {
          getAllBasketPayment?.orderTotalDiscount != 0 && <div className='payment-right-descriptionColor'>{t('discountAmount')}:  <CurrencyFormatter locale="tr" currency="TRY" value={getAllBasketPayment?.orderTotalDiscount} /></div>
        }
        {
         getAllBasketPayment?.bagPrice != 0 && getAllBasketPayment?.bagPrice != null && <>
          <div className='payment-right-descriptionColor'>
          {t('bagAmount')}:  <CurrencyFormatter locale="tr" currency="TRY" value={getAllBasketPayment?.bagPrice} /> {" "}
          </div>
          <div>
          {
          getAllBasketPayment?.bagUsage?.map((bag,i) => (
            <div className='payment-right-descriptionColorSm' key={i}>
              - {bag.productName}: {bag.quantity} {t('piece')}
            </div>
          ))
          }
          </div>
          </>
        }
        
        {
          getAllBasketPayment?.minOrderAmount != 0 && getAllBasketPayment?.minOrderAmount != null && <div className='payment-right-description'>{t('minSalesAmount')}: {getAllBasketPayment?.minOrderAmount},00 TL</div>
        }
        {/* <div className='payment-right-textCode'>
          <div className="payment-right-textCode-left">İndirim Kodu</div>
          <div className="payment-right-textCode-right">Kullan</div>
        </div> */}
        {/* <ChoiceComp title={"Kampanya"} description1={"Kampanyaya katılmak istemiyorum."} description2={"Kampanya adı 1"} description3={"Kampanya adı 2"} name = "3" type={"radio"}/> */}
        <div className='payment-left-choiceComp'>
              <div className='payment-left-choiceComp-title'>{t('paymentOptions')}</div>
              <div>
                {
                  getAllBasketPayment?.paymentMethods?.map((payment,i) => (
                    <div key={i} className='payment-left-choiceComp-container'><Radio checked={paymentChoice?.paymentTypeId == payment.id} onChange={e => paymentChange(e, payment?.id, payment?.systemName)} name={"paymentTypeId"}/> {payment?.logoLink && <img className='paymentLogoLink' src={payment?.logoLink} alt="" />} {payment?.name}</div>
                  ))
                }
              {/* <div className='payment-left-choiceComp-container'><Radio name={4}/> Nakit</div>
              <div className='payment-left-choiceComp-container'><Radio name={4}/> Kart ile Öde</div>
              <div className='payment-left-choiceComp-container'><Radio name={4}/> <img src={images.multinet} alt="" /> Multinet ile Öde</div>
              <div className='payment-left-choiceComp-container'><Radio name={4}/> <img src={images.sodexo} alt="" /> Sodexo ile Öde</div> */}
              </div> 
            </div>
            <div className='payment-right-complete'>
              <Checkbox checked={paymentChoice?.salesContrat} onChange={e => setPaymentChoice(prev => ({...prev,salesContrat:e.target.checked}))} className={"paymentRightCheckbox pb-0"} textLabel={<span> <Trans 
              i18nKey='distanceSellingAgreementText'
              components={{ 
                triggerBtn1: <TriggerButton onApprove={() => ({...prev,salesContrat:true})} text={t('preInfoForm')} referance='on-bilgilendirme-formu'/>,
                triggerBtn2: <TriggerButton onApprove={() => ({...prev,salesContrat:true})} text={t('distanceSellingAgree')} referance='mesafeli-satis-sozlesmesi'/>,
              }}
              /></span>}/>
              {
                getAllBasketPayment?.warnings?.length > 0 && <div className="body-s text-danger">({getAllBasketPayment?.warnings?.join(', ')})</div>
              }
              <Button onClick={completeOrder} className={"claretredRoundedBtn"}  icon={''} text={t('completeOrder')}/>
            </div>
        </>
       }
       
      
    </div>
  )
}

export default PaymentRight